import { render, staticRenderFns } from "./oauth2-binding.vue?vue&type=template&id=21695ad6&scoped=true"
import script from "./oauth2-binding.vue?vue&type=script&lang=js"
export * from "./oauth2-binding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21695ad6",
  null
  
)

export default component.exports